import { useState } from 'react';

interface ModelConfigSectionProps {
  extraction: {
    model_name?: string | null;
    model_version?: string | null;
    model_temperature?: number | null;
    model_max_tokens?: number | null;
    model_top_p?: number | null;
    model_presence_penalty?: number | null;
    model_frequency_penalty?: number | null;
    model_seed?: number | null;
    prompt_id?: string | null;
    source?: string;
    validated_at?: string | null;
    created_at?: string;
  };
}

export function ModelConfigSection({ extraction }: ModelConfigSectionProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Don't show if no model info
  if (!extraction.model_name && !extraction.model_version) {
    return null;
  }

  return (
    <div className="border-t border-gray-200 pt-6 mt-6">
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full flex items-center justify-between text-left text-sm font-medium text-gray-700 hover:text-gray-900"
      >
        <span>⚙️ Configuration du modèle</span>
        <span className="text-gray-400">{isExpanded ? '▼' : '▶'}</span>
      </button>

      {isExpanded && (
        <div className="mt-4 bg-gray-50 rounded-lg p-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {/* Model Name */}
            {extraction.model_name && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Modèle</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_name}</div>
              </div>
            )}

            {/* Model Version */}
            {extraction.model_version && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Version</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_version}</div>
              </div>
            )}

            {/* Temperature */}
            {extraction.model_temperature !== null && extraction.model_temperature !== undefined && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Temperature</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_temperature}</div>
              </div>
            )}

            {/* Max Tokens */}
            {extraction.model_max_tokens && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Max Tokens</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_max_tokens.toLocaleString()}</div>
              </div>
            )}

            {/* Top P */}
            {extraction.model_top_p !== null && extraction.model_top_p !== undefined && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Top P</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_top_p}</div>
              </div>
            )}

            {/* Presence Penalty */}
            {extraction.model_presence_penalty !== null && extraction.model_presence_penalty !== undefined && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Presence Penalty</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_presence_penalty}</div>
              </div>
            )}

            {/* Frequency Penalty */}
            {extraction.model_frequency_penalty !== null && extraction.model_frequency_penalty !== undefined && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Frequency Penalty</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_frequency_penalty}</div>
              </div>
            )}

            {/* Seed */}
            {extraction.model_seed !== null && extraction.model_seed !== undefined && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Seed</div>
                <div className="text-sm font-mono text-gray-900">{extraction.model_seed}</div>
              </div>
            )}

            {/* Statut validation */}
            <div>
              <div className="text-xs font-medium text-gray-500 mb-1">Statut</div>
              <div className="text-sm font-mono text-gray-900">
                {extraction.validated_at ? 'Validé' : 'IA (non validé)'}
              </div>
            </div>

            {/* Created At */}
            {extraction.created_at && (
              <div>
                <div className="text-xs font-medium text-gray-500 mb-1">Date d'extraction</div>
                <div className="text-sm font-mono text-gray-900">
                  {new Date(extraction.created_at).toLocaleString('fr-CA', {
                    timeZone: 'America/Montreal',
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
